if( document.querySelector('.js-menu-input-cafe') ) {
    $('.single_add_to_cart_button').on('click', function(e) { 
        e.preventDefault();
    });

    jQuery(document).ready(function($) {
        $('.single_add_to_cart_button').on('click', function(e){ 
        e.preventDefault();
        $thisbutton = $(this),
                    $form = $thisbutton.closest('form.cart'),
                    id = $thisbutton.val(),
                    product_qty = $form.find('input[name=quantity]').val() || 1,
                    product_id = $form.find('input[name=product_id]').val() || id,
                    variation_id = $form.find('input[name=variation_id]').val() || 0;
        var data = {
                action: 'ql_woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
            };
        var timer;
        $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                    $thisbutton.html('<i class="fa-solid fa-spinner"></i>');
                },
                complete: function (response) {
                    $thisbutton.addClass('added').removeClass('loading');
                    $thisbutton.html('Added to order <i class="fa-solid fa-check"></i>');

                    clearTimeout(timer);
                    timer = setTimeout(function (event) {
                       $thisbutton.closest('.js-cafe-menu-item-popup').addClass('resturant__input__tab__body__item__options--hide');
                        setTimeout(function (event) {
                           $thisbutton.closest('.js-cafe-menu-item-popup').addClass('hide');
                           $thisbutton.closest('.js-cafe-menu-item-popup').removeClass('resturant__input__tab__body__item__options--hide');
                           $thisbutton.html('Add to order');
                        }, 1000);
                    }, 1000);


                }, 
                success: function (response) { 
                    $('.js-cafe-cart-total').html(response);
                    // console.log(response);
                    if (response.error & response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else { 
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                    } 
                }, 
            }); 
         }); 
    });
}